import React from 'react';
import { Button, Form, Input, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { FORM_NOT_EMPTY_RULE } from '../../../../../utils';
import { PaddedButton } from '../styles';
import { ERROR_MESSAGES, LAYOUT_STYLES, TAIL_STYLES } from '../constants';

const SwidForm = ({ form, onSubmit, onBack }) => {
  return (
    <Form {...LAYOUT_STYLES} form={form} onFinish={onSubmit}>
      <Form.Item
        label="SWID"
        name="swid"
        rules={[{ required: true, message: ERROR_MESSAGES.REQUIRED_SWID }, FORM_NOT_EMPTY_RULE]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={
          <span>
            Nickname&nbsp;
            <Tooltip title="Customize Profile Nickname: Links to your Profile, not the Account">
              <InfoCircleOutlined />
            </Tooltip>
          </span>
        }
        name="nickname"
        rules={[{ required: true, message: ERROR_MESSAGES.REQUIRED_NICKNAME }, FORM_NOT_EMPTY_RULE]}
      >
        <Input />
      </Form.Item>
      <Form.Item {...TAIL_STYLES}>
        <Button onClick={onBack}>Back</Button>
        <PaddedButton type="primary" htmlType="submit">
          Submit
        </PaddedButton>
      </Form.Item>
    </Form>
  );
};

export default SwidForm;
